import React, { useState } from "react";
import styles from "./styles.css";
// import PropTypes from "prop-types";

const TabMenu = ({
    children,
    defaultSelectedIndex = 0
}) => {

    const [activeIndex, setActiveIndex] = useState(defaultSelectedIndex);

    const onTabClick = ({ index }) => {
        setActiveIndex(index);
    };

    return children({
        onClick: onTabClick,
        currentActiveIndex: activeIndex
    });

};

export default TabMenu;
